export default ({
  CARD_STATE_TOGGLE_BY_ID       : 'CARD_STATE_TOGGLE_BY_ID',
  CARD_STATE_SET_BY_ID_INITIAL  : 'CARD_STATE_SET_BY_ID_INITIAL',
  CARD_STATE_AUTO_HIDE          : 'CARD_STATE_AUTO_HIDE'
});